import { Platform, View, TouchableHighlight, StyleSheet } from "react-native";
import { Center, Text } from "native-base";
import React, { useState } from "react";
import * as faCharCodes from "../../../assets/consts/faCharCodes";
import FontAwesomeIcon from "../../components_v2/FontAwesomeIcon";
import Theme from "../../argon-ui/Theme";
import { Badge } from "react-native-material-bottom-navigation";
import { IS_MOBILE } from "../../locales/translate";
import { APP_VERSION } from "../../../assets/consts";
import { getIsRTL } from "../../util";

interface Props {
  tabs: any;
  navigation: any;
}
const Menu = (props: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const { tabs, navigation } = props;
  const onClose = () => {
    setIsOpen(false);
  };
  return (
    <View
      style={[
        {
          width: 70,
          height: "100%",
          alignItems: "flex-end",
          overflow: isOpen ? "visible" : "hidden",
        },
        IS_MOBILE || !getIsRTL()
          ? {
              borderLeftWidth: 2,
              borderLeftColor: Theme.COLORS.BLOCK,
            }
          : {
              borderRightWidth: 2,
              borderRightColor: Theme.COLORS.BLOCK,
            },
      ]}
    >
      <View
        style={[
          {
            alignItems: "flex-end",
            height: "100%",

            padding: 5,
            paddingVertical: 20,
            borderRightColor: Theme.COLORS.BLOCK,
            borderRightWidth: 2,
          },
          isOpen
            ? {
                width: 200,
                backgroundColor: Theme.COLORS.STATUS_BAR,
              }
            : { width: 70 },
          Platform.OS !== "web" &&
            isOpen && {
              borderLeftColor: Theme.COLORS.BLOCK,
              borderLeftWidth: 2,
            },
        ]}
      >
        <TouchableHighlight
          underlayColor={"transparent"}
          style={[
            {
              alignItems: "center",
              paddingVertical: 8,
              borderRadius: 3,
              marginBottom: 10,
            },
            Platform.OS === "web"
              ? getIsRTL()
                ? { paddingLeft: 12 }
                : { paddingRight: 9 }
              : { paddingRight: 12 },
          ]}
          onPress={() => {
            setIsOpen(!isOpen);
          }}
        >
          <View
            style={{
              position: "relative",
              width: "100%",
              flexDirection: "row-reverse",
            }}
          >
            <View style={styles.closeIconContainer}>
              <FontAwesomeIcon
                icon={isOpen ? faCharCodes.faTimes : faCharCodes.faBars}
                size={18}
                color={isOpen ? Theme.COLORS.ERROR : Theme.COLORS.GRAY_DARK}
              />
            </View>
          </View>
          {/* === menu body === */}
        </TouchableHighlight>
        {tabs.map((tab: any, i: number) => {
          return (
            <View
              style={[
                styles.categoryContainer,
                { flex: tab?.tabItem.length },
                tabs.length - 1 !== i && {
                  borderBottomWidth: 1,
                  borderBottomColor: Theme.COLORS.WHITE,
                },
              ]}
              key={i}
            >
              {tab?.tabItem.map((_tabItem: any, index: number) => {
                if (_tabItem.hide !== undefined && !_tabItem.hide) {
                  return null;
                }
                return (
                  <MenuItem item={_tabItem} key={index} onClose={onClose} />
                );
              })}
            </View>
          );
        })}
        {isOpen && (
          <TouchableHighlight
            underlayColor="transparent"
            style={{
              position: "absolute",
              bottom: 0,
              width: "100%",
            }}
            onPress={() => {
              if (IS_MOBILE) {
                navigation.navigate("Updates");
                onClose();
              }
            }}
          >
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <Text
                style={{
                  textAlign: "center",
                  fontSize: 10,
                  padding: 10,
                  color: Theme.COLORS.MUTED,
                  alignSelf: "center",
                }}
                onPress={() => {
                  if (IS_MOBILE) {
                    navigation.navigate("Updates");
                    onClose();
                  }
                }}
              >
                version: {APP_VERSION}
              </Text>
            </View>
          </TouchableHighlight>
        )}
      </View>
    </View>
  );
};

export default Menu;

const MenuItem = (props: any) => {
  const { item, onClose } = props;
  return (
    <View
      style={{
        position: "relative",
        width: "100%",
        alignItems: "flex-end",
        justifyContent: "center",
        flex: 1,
        marginBottom: 5,
      }}
    >
      <TouchableHighlight
        underlayColor={"transparent"}
        style={[
          {
            width: 160,
            alignItems: "center",
            paddingVertical: 8,
            borderRadius: 3,
          },
        ]}
        onPress={() => {
          onClose();
          item.callback();
        }}
      >
        <View
          style={{
            position: "relative",
            width: "100%",
            flexDirection: "row-reverse",
          }}
        >
          {item.badge > 0 && (
            <Badge
              style={[
                {
                  minWidth: 7,
                  height: 7,
                  position: "absolute",
                  top: -10,
                  justifyContent: "center",
                  alignItems: "center",
                },
                Platform.OS === "web" ? { left: 22 } : { right: 22 },
                item.badge > 1 && {
                  width: 12,
                  minWidth: 12,
                  height: 12,
                },
              ]}
            >
              {item.badge > 1 ? (
                <Text fontSize={9} color={Theme.COLORS.WHITE}>
                  {item.badge}
                </Text>
              ) : (
                <View style={{ display: "none" }} />
              )}
            </Badge>
          )}
          <Center
            w="20px"
            style={
              Platform.OS === "web" ? { marginLeft: 5 } : { marginRight: 5 }
            }
          >
            <FontAwesomeIcon
              icon={item.icon}
              size={18}
              color={Theme.COLORS.GRAY_DARK}
            />
          </Center>
          <Text
            style={[
              {
                marginHorizontal: 5,
                flex: 1,
                fontSize: 12,
              },
            ]}
          >
            {item.label ? item.label : null}
          </Text>
        </View>
      </TouchableHighlight>
    </View>
  );
};

const styles = StyleSheet.create({
  categoryContainer: {
    padding: 15,
    marginBottom: 10,
    width: "100%",
    flex: 1,
    justifyContent: "center",
  },
  closeIconContainer: {
    width: 35,
    height: 35,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 5,
    backgroundColor: Theme.COLORS.GRAY_LIGHT,
    shadowColor: Theme.COLORS.MUTED,
    shadowOffset: {
      width: 0,
      height: 3,
    },
    shadowOpacity: 0.2,
    shadowRadius: 6.65,
    elevation: 4,
  },
});
